import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { CampaignBuilderScreen } from './CampaignBuilderScreen';
import { parseBuilderStep } from './builderSteps';

/** The route `/outreach/campaigns/new?song=&campaign=&step=` (design outreach-v2 b to f). */
const CampaignBuilderViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const [searchParams] = useSearchParams();
  if (accountId === null) {
    return <LoadingView />;
  }
  return (
    <CampaignBuilderScreen
      accountId={accountId}
      initialSong={searchParams.get('song')}
      campaignUuid={searchParams.get('campaign')}
      initialStep={parseBuilderStep(searchParams.get('step'))}
    />
  );
};

export const CampaignBuilderView = TypedMemo(CampaignBuilderViewComponent);
